module.exports = __webpack_public_path__ + "static/media/homeHeader1.78420128.jpg";